import { render, staticRenderFns } from "./personalData.vue?vue&type=template&id=462ee7c8&scoped=true&"
import script from "./personalData.vue?vue&type=script&lang=js&"
export * from "./personalData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462ee7c8",
  null
  
)

export default component.exports